<template>
  <section class="f-popover-top">
    <div class="container" ref="popoverTop">
      <div class="btn" @click="toggle"><slot name="container"/>
        <div class="popover-top-more" v-if="focus">
          <slot name="list"></slot>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'f-popover-top',
    props: {
      actions: {
        type: Array,
        default: null
      }
    },
    data() {
      return {
        focus: false,
      }
    },
    methods: {
      toggle() {
        this.focus = !this.focus;
      },
      documentClick(e){
        let el = this.$refs.popoverTop;
        let target = e.target;
        if ( el !== target && !el.contains(target)) {
          this.focus = false;
        }
      }
    },
    created () {
      document.addEventListener('click', this.documentClick);
    },
    destroyed () {
      document.removeEventListener('click', this.documentClick);
    },
  }
</script>

<style scoped>
  .container {
    display: flex;
    cursor: pointer;
  }
  /* Button 'more' */
  .btn {
    position: relative;
    border: none;
    background: transparent;
  }
  .btn:focus {
    outline: none;
  }
  .btn > .ab-icon {
    margin: 0;
    border-radius: 50%;
  }
  .btn:focus .ab-icon {
    box-shadow: var(--app-ctn-shadow);
  }

  /* Used for UserList page */
  .btn .client-list {
    font-family: var(--app-font-regular);
    color: var(--app-dark-grey);
  }
  /* Popover */
  .popover-top-more {
    position: absolute;
    min-width: 8.5rem;
    top: 100%;
    background: var(--app-white-color);
    border-radius: 5px;
    box-shadow: 0px 6px 18px rgba(0, 0, 0, 0.06);
    z-index: 999;
  }
  .tooltip-center .popover-top-more {
    margin-left: -50%;
  }
  .tooltip-right .popover-top-more {
    right: 0.15rem;
  }
  .popover-top-more:focus {
    outline: none;
  }
  /* Arrow */
  .popover-top-more:after {
    position: absolute;
    content: " ";
    bottom: 100%;
    border: solid transparent;
    border-width: 0.5rem;
    border-color: rgba(136, 183, 213, 0);
    border-bottom-color: var(--app-white-color);
    box-shadow: 0px 6px 18px rgba(0, 0, 0, 0.06);
    margin-left: -0.7rem;
    height: 0;
    width: 0;
    pointer-events: none;
  }
  .tooltip-center .popover-top-more:after {
    left: 50%;
  }
  .tooltip-right .popover-top-more:after {
    right: 0.25rem;
  }
  /* List */
  .f-popover-top .item {
    display: block;
    width: 100%;
    padding: 0.75rem;
  }
  .f-popover-top ul{
    list-style-type: none;
    margin: 0;
    padding: 0;
    font-family: var(--app-font-medium);
  }
  .f-popover-top li {
    border-radius: 5px;
  }
  .f-popover-top li:hover {
    background-color: var(--app-light-grey);
    transition: 0.25s;
  }
  .popover-top-more li a {
    color: var(--app-drak-grey);
    text-decoration: none;
  }
  /* Used for UserList page */
  .popover-top-more .client-name {
    background-color: var(--app-white-color);
    padding: 0.75rem;
  }
</style>
<style>
  /* Override ab-icon default style for icons in popover */
  .popover-top-more .ab-icon {
    color: var(--app-primary-color);
    position: relative;
    width: 1rem;
    height: 1rem;
    margin: 0;
    margin-right: 0.4rem;
    top: -1px;
  }
</style>